export default "__VITE_ASSET__jIikogta__"